import React from 'react'
import RootsTechBannerBase from './internal/RootsTechBannerBase'
import RootsTechBannerProvider from './internal/RootsTechBannerProvider'

export default function RootsTechBanner({
  analyticsName = 'UnknownBanner',
  visibility,
  featureFlag,
  startExpandedVisibility,
  startDate,
  endDate,
  cacheKey,
  children,
}) {
  return (
    <RootsTechBannerProvider
      startExpandedVisibility={startExpandedVisibility}
      analyticsName={analyticsName}
      cacheKey={cacheKey}
    >
      <RootsTechBannerBase visibility={visibility} startDate={startDate} endDate={endDate} featureFlag={featureFlag}>
        {children}
      </RootsTechBannerBase>
    </RootsTechBannerProvider>
  )
}
